(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3157],{

/***/ 31549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91289);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useMetaDescription = function useMetaDescription() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .q)();
  return function (text) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
      name: "description",
      content: text || t("meta.description")
    });
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMetaDescription);

/***/ }),

/***/ 82577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var app_context_player_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48346);
/* harmony import */ var app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22564);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31549);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var services_hooks_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90413);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);










var PlayerPage = function PlayerPage() {
  var _router$query$permali;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var _usePlayerContext = (0,app_context_player_context__WEBPACK_IMPORTED_MODULE_0__/* .usePlayerContext */ .gD)(),
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen,
      httpMode = _usePlayerContext.httpMode,
      setHttpMode = _usePlayerContext.setHttpMode;

  var getMetaDescription = (0,app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();
  var permalink = typeof router.query.permalink === "string" ? router.query.permalink : (_router$query$permali = router.query.permalink) === null || _router$query$permali === void 0 ? void 0 : _router$query$permali.join("/");

  var _useGetPillowRadio = (0,services_hooks_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useGetPillowRadio */ .FM)(permalink || ''),
      data = _useGetPillowRadio.data;

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setHttpMode(true);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _data$data$body;

    setFullscreenPlayerInitialyOpen(true);
    var activeCategory = data === null || data === void 0 ? void 0 : (_data$data$body = data.data.body) === null || _data$data$body === void 0 ? void 0 : _data$data$body.content;
    setPlayerEnabled(true);
    dispatch(app_store_slices_player__WEBPACK_IMPORTED_MODULE_1__/* .playerActions.selectTrack */ .i9.selectTrack({
      category: activeCategory || {
        permalink: permalink
      },
      podcast: null
    }));
  }, [data]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
      children: getMetaDescription()
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PlayerPage);

/***/ }),

/***/ 40518:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/[...permalink]",
      function () {
        return __webpack_require__(82577);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(40518); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);